export const EMAIL_MAX = 254;
export const LOCAL_MAX = 64;
export const NAME_MAX = 100;

export const EMAIL_RE =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

const EMAIL_INVALID_MESSAGE = "Confira o e-mail: ele precisa ter o formato nome@exemplo.com.";

export function validateEmailValue(value) {
  const email = String(value ?? "").trim().toLowerCase();
  if (!email) {
    return EMAIL_INVALID_MESSAGE;
  }
  if (email.length > EMAIL_MAX || !EMAIL_RE.test(email)) {
    return EMAIL_INVALID_MESSAGE;
  }
  const [local, domain] = email.split("@");
  if (!local || !domain || local.length > LOCAL_MAX) {
    return EMAIL_INVALID_MESSAGE;
  }
  if (local.startsWith(".") || local.endsWith(".") || local.includes("..")) {
    return EMAIL_INVALID_MESSAGE;
  }
  return "";
}

export const CONSENT_REQUIRED_MESSAGE = "Para entrar na lista, marque a autorização acima.";

export function validateConsentValue(consent) {
  return consent === true ? "" : CONSENT_REQUIRED_MESSAGE;
}

export function validateNameValue(value) {
  if (value === undefined || value === null || value === "") {
    return "";
  }
  const name = String(value);
  if (/[\x00-\x1F\x7F]/.test(name)) {
    return "Nome inválido.";
  }
  const trimmed = name.trim();
  if (trimmed.length > NAME_MAX) {
    return `Nome deve ter no máximo ${NAME_MAX} caracteres.`;
  }
  return "";
}
